"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _this = void 0;

var _default = /*#__PURE__*/_react.default.memo(function () {
  (0, _newArrowCheck2.default)(this, _this);
  return /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.6965559,16.7233146 L20.8268863,7.96758429 C21.0577046,7.746236 21.0577046,7.38735951 20.8268863,7.16601122 C20.7160434,7.05971602 20.5657082,7 20.4089527,7 L1.5910473,7 C1.26462089,7 1,7.253764 1,7.56679776 C1,7.71712187 1.06227088,7.86128909 1.17311375,7.96758429 L10.3034441,16.7233146 C10.6881413,17.0922285 11.3118587,17.0922285 11.6965559,16.7233146 Z",
    transform: "rotate(90 11 12)"
  });
}.bind(void 0));

exports.default = _default;